import { snakeCase } from "case-anything";

export default function () {
  const transformUserData = (
    data,
    state,
    options = {
      stateName: null,
    }
  ) => {
    let userData = {};

    if (options.stateName) {
      userData = state[options.stateName];
    }

    const setUserProperty = (object, key, value) => {
      var keys = key.split(".");

      while (keys.length > 1) {
        var k = keys.shift();

        if (!(k in object)) {
          object[k] = {};
        }

        object = object[k];
      }

      object[keys[0]] = value;
    };

    Object.keys(data).forEach((key) => {
      let value = data[key];

      switch (key) {
        case "phone":
          setUserProperty(userData, "mobileNumber", value);
          break;
        case "phoneVerified":
          setUserProperty(userData, "mobileNumber_verified", value);
          break;
        case "phone_verified":
          setUserProperty(userData, "mobileNumber_verified", value);
          break;
        case "email_verified":
          setUserProperty(userData, "emailVerified", value);
          break;
        case "tfn":
          setUserProperty(userData, "tfn", value);
          break;
        case "covid_cert":
          setUserProperty(userData, "covidCert", value);
          break;
        case "covid_cert_pro":
          setUserProperty(userData, "covidCertPro", value);
          break;
        case "ahpraExpDate":
        case "ahpra.date":
          setUserProperty(userData, "ahpra.date", value);
          break;
        case "ahpra":
        case "ahpra.number":
          setUserProperty(userData, "ahpra.number", value);
          break;
        case "dateOfBirth":
          setUserProperty(userData, "birthday", value);
          break;

        case "lat":
          setUserProperty(userData, "address.lat", value);
          break;
        case "lng":
          setUserProperty(userData, "address.lng", value);
          break;
        case "street":
          setUserProperty(userData, "address.street", value);
          break;
        case "suburb":
          setUserProperty(userData, "address.suburb", value);
          break;
        case "state":
          setUserProperty(userData, "address.state", value);
          break;
        case "country":
          setUserProperty(userData, "address.country", value);
          break;
        case "postcode":
          setUserProperty(userData, "address.postcode", value);
          break;
        case "timeOffset":
          setUserProperty(userData, "timeOffset", value);
          break;
        case "timezone":
          setUserProperty(userData, "timezone", value);
          break;
        case "identity_document":
          setUserProperty(userData, "identityDocument", value);
          break;
        case "insurance_document":
          setUserProperty(userData, "insuranceDocument", value);
          break;
        case "beneficiaryId":
          setUserProperty(userData, "airwallexInfo.beneficiaryId", value);
          break;
        case "bankVerification.verified":
          setUserProperty(userData, "bankVerification.verified", value);
          break;
          case "bankVerification.amount":
            setUserProperty(userData, "bankVerification.amount", value);
            break;
        case "businessNameBilling":
          setUserProperty(userData, "businessNameBilling", value);
          break;
        case "abn":
          setUserProperty(userData, "abn", value);
          break;
        case "accountName":
          setUserProperty(userData, "accountName", value);
          break;
        case "name":
          setUserProperty(userData, "name", value);
          break;
        case "accountNumber":
          setUserProperty(userData, "accountNumber", value);
          break;
          case "site.is_record_shifts_enabled":
            setUserProperty(userData, "site.isRecordShiftsEnabled", value);
            break;
        case "billingAddress":
        case "billing.address":
          setUserProperty(userData, "billing.address.text", value);
          break;
        case "scriptsPerDayId":
          setUserProperty(userData, "environment.scriptsPerDay", value);
          break;
        case "average_scripts_saturday_id":
        setUserProperty(userData, "environment.average_scripts_saturday_id", value);
        break;
        case "average_scripts_sunday_id":
          setUserProperty(userData, "environment.average_scripts_sunday_id", value);
          break;
        case 'number_of_patients' :
          setUserProperty(userData, 'environment.number_of_patients', value)
          break
        case "dispensingSoftId":
          setUserProperty(userData, "environment.software", value);
          break;
        case "pharmacyServices":
          setUserProperty(userData, "environment.services", value);
          break;
          case "group_contract":
            setUserProperty(userData, "groupContract", value);
            break;
         
        case "billingInfo":
          if (data[key]) {
            
            let billingInfo = transformUserData(data[key], state);
            Object.keys(billingInfo).forEach((key) => {
              
              userData[key] = billingInfo[key];
              switch (key) {
                case "billingAddress":
                  case "billing.address":
                    setUserProperty(userData, `billing.address.${key}`, value);
                    break;
                case "type":
                case "billingAccountType":
                  setUserProperty(userData, `billing.${key}`, billingInfo[key]);
                  break;
                case "businessName":
                case "businessNameBilling":
                  setUserProperty(userData, `billing.${key}`, billingInfo[key]);
                  break;
                case "bsb":
                case "billingBsb":
                  setUserProperty(userData, `billing.${key}`, billingInfo[key]);
                  setUserProperty(userData, `billing.bankBsb`, billingInfo[key]);
                  break;
                case "bankName":
                case "bankNameBilling":
                  setUserProperty(userData, `billing.${key}`, billingInfo[key]);
                  setUserProperty(userData, `billing.bankName`, billingInfo[key]);
                  break;
                case "bankAccountNumber":
                case "accountNumber":
                  setUserProperty(userData, `billing.${key}`, billingInfo[key]);
                  setUserProperty(userData, `billing.bankAccountNumber`, billingInfo[key]);
                  break;
                case "bankAccountName":
                case "accountName":
                  setUserProperty(userData, `billing.${key}`, billingInfo[key]);
                  setUserProperty(userData, `billing.bankAccountName`, billingInfo[key]);
                  break;
                case "routingNumber":
                  setUserProperty(userData, `billing.${key}`, billingInfo[key]);
                  break;
                }
  
            });
          }
          break;
        case "bankVerification":
          if (data[key]) {
            let bankVerification = transformUserData(data[key], state);
            Object.keys(bankVerification).forEach((key) => {
              userData[key] = bankVerification[key];
              if(key == 'verified'){
                setUserProperty(userData, "bankVerification.verified", bankVerification[key]);
              }
              if(key == 'amount'){
                setUserProperty(userData, "bankVerification.amount", bankVerification[key]);
              }
            });
          }
          else {
            // If bankVerification is null or falsy, set bankVerification.verified to 0
            setUserProperty(userData, "bankVerification.verified", 0);
            setUserProperty(userData, "bankVerification.amount", null);
        }
          break;
        case "airwallexInfo":
          if (data[key]) {
            let airwallexInfo = transformUserData(data[key], state);
            Object.keys(airwallexInfo).forEach((key) => {
              userData[key] = airwallexInfo[key];
            });
          }
          break;
        case "details":
          if (data[key]) {
            let details = transformUserData(data[key], state);
            Object.keys(details).forEach((key) => {
              userData[key] = details[key];
            });
          }
          break;
        case "terms_and_condition":
          setUserProperty(userData, "termsAndCondition", value);
          break;
       
        case "emergencyPhone":
          setUserProperty(userData, "emergencyContact.mobileNumber", value);
          break;
        case "emergencyFirstName":
          setUserProperty(userData, "emergencyContact.firstName", value);
          break;
        case "emergencyLastName":
          setUserProperty(userData, "emergencyContact.lastName", value);
          break;
        case "notifyChatMessage":
        case "notifyMatchingJob":
        case "notifyBookedShift":
        case "notifySubmitTimesheet":
        case "notifyTimesheetConfirmed":
        case "notifyPharmacyCancelShift":
        case "notifyShiftReminderToday":
        case "notifySomeoneBookedShift":
        case "notifyShiftReminderEarly":
        case "notifyVerifyTimesheet":
        case "notifyDailyReminder":
        case "notifyHourlyReminder":
        case "notifyShiftApplication":
          setUserProperty(userData, "notifications." + key, value);
          break;
        case "workOutsideMetro":
          setUserProperty(userData, "travel.workOutsideMetro", value);
          break;
        case "shortStint":
          setUserProperty(userData, "travel.shortStint", value);
          break;
        case "longTermJob":
          setUserProperty(userData, "travel.longTermJob", value);
          break;
        case "support_site":
          setUserProperty(userData, "supportSite", value);
          break;
        case "profileRequirements":
          setUserProperty(userData, "profileRequirements", value);
          break;
        default:
          setUserProperty(userData, key, value);
          break;
     
  }
    });
    return userData;
  };

  const transformUserDataForRequest = (data) => {
    let formDataObject = {};
    console.log("databata:", data);
    if (data instanceof FormData) {
      formDataObject = data;
    } else {
      Object.keys(data).forEach((key) => {
        let value = data[key];
        console.log("KEY:", key);
       
        switch (key) {
          case "mobileNumber":
            formDataObject.phone = value;
            break;
          case "firstName":
            formDataObject.name = value;
            break;
          case "lastName":
            formDataObject.last_name = value;
            break;
          case "preferredName":
            formDataObject.preferred_name = value;
            break;
          case "ahpraNumber":
            formDataObject.ahpra = value;
            break;
          case "ahpraExpiryDate":
            console.log("ahpra_exp_date:", value);
            formDataObject.ahpra_exp_date = value;
            break;
          case "birthday":
            formDataObject.date_of_birth = value;
            break;

          case "address":
            Object.keys(data[key]).forEach((addressKey) => {
              let value = data[key][addressKey];
              switch (addressKey) {
                case "lat":
                  formDataObject.lat = value;
                  break;
                case "lng":
                  formDataObject.lng = value;
                  break;
                case "country":
                  formDataObject.country = value;
                  break;
                case "postcode":
                  formDataObject.postcode = value;
                  break;
                case "city":
                  formDataObject.city = value;
                  break;
                case "state":
                  formDataObject.state = value;
                  break;
                case "vicinity":
                  formDataObject.vicinity = value;
                  break;
                case "street":
                  formDataObject.street = value;
                  break;
                case "suburb":
                  formDataObject.suburb = value;
                  break;
                case "timeOffset":
                  formDataObject.time_offset = value;
                  break;
                case "timezone":
                  formDataObject.timezone = value;
                  break;
                case "subpremise":
                    formDataObject.subpremise = value;
                    break;
                case "text":
                      formDataObject.full_address = value;
                break;
                case "type":
                formDataObject.fileType = value;
                break;
              }
            });
            break;

          case "billingAddress":
            formDataObject.billing_address = value.text;
            break;
          case "billingEmail":
            formDataObject.billing_email = value;
            break;
          case "billingEmail2":
          formDataObject.billing_email2 = value;
          break;
          case "timeOffset":
            formDataObject.time_offset = value;
            break;
          case "timezone":
            formDataObject.timezone = value;
            break;
          case "businessName":
            formDataObject.business_name = value;
            break;
          case "abn":
            formDataObject.abn = value;
            break;
          case "bankName":
            formDataObject.bank_name = value;
            break;
            case "billingBankName":
            formDataObject.bank_name = value;
            break;
          case "depositAmount":
            formDataObject.amount = value;
            break;
          case "bankAccountName":
            formDataObject.account_name = value;
            break;
          case "accountType":
          formDataObject.account_type = value;
          break;
          case "bsb":
            formDataObject.bsb = value;
            break;
          case "bankBsb":
            formDataObject.bsb = value;
            break;
          case "bankAccountNumber":
            formDataObject.account_number = value;
            break;
          case "scripts":
            formDataObject.scripts_per_day_id = value;
            break;
          case "average_scripts_saturday_id":
            formDataObject.average_scripts_saturday_id = value;
            break;
          case "average_scripts_sunday_id":
            formDataObject.average_scripts_sunday_id = value;
            break;
          case "number_of_patients":
            formDataObject.number_of_patients = value
            break
          case "software":
            formDataObject.dispensing_soft_id = value;
            break;
          case "services":
            formDataObject.pharmacy_services = value;
            break;
          case "schedule":
            formDataObject.schedule = Object.keys(value).reduce((v, key) => {
              v[key] = +value[key];
              return v;
            }, {});
            break;
          case "minRate":
            formDataObject.min_rate = value;
            break;
          case "weekendRate":
            formDataObject.weekend_rate = value;
            break;
          case "emergencyContact":
            Object.keys(data[key]).forEach((emergencyContactKey) => {
              let value = data[key][emergencyContactKey];
              switch (emergencyContactKey) {
                case "mobileNumber":
                  formDataObject.emergency_phone = value;
                  break;
                case "firstName":
                  formDataObject.emergency_first_name = value;
                  break;
                case "lastName":
                  formDataObject.emergency_last_name = value;
                  break;
              }
            });
            break;
          case "additionalName1":
            formDataObject.additional_name1 = value;
            break;
          case "additionalEmail1":
            formDataObject.additional_email1 = value;
            break;
          case "additionalPhone1":
            formDataObject.additional_phone1 = value;
            break;
          case "additionalName2":
            formDataObject.additional_name2 = value;
            break;
          case "additionalPhone2":
            formDataObject.additional_phone2 = value;
            break;
          case "notifyChatMessage":
          case "notifyMatchingJob":
          case "notifyBookedShift":
          case "notifySubmitTimesheet":
          case "notifyTimesheetConfirmed":
          case "notifyPharmacyCancelShift":
          case "notifyShiftReminderToday":
          case "notifySomeoneBookedShift":
          case "notifyShiftReminderEarly":
          case "notifyVerifyTimesheet":
          case "notifyDailyReminder":
          case "notifyHourlyReminder":
          case "notifyShiftApplication":
            formDataObject[snakeCase(key)] = value;
            break;
          case "travel":
            Object.keys(data[key]).forEach((travelKey) => {
              let value = data[key][travelKey];
              switch (travelKey) {
                case "workOutsideMetro":
                  formDataObject.work_outside_metro = value;
                  break;
                case "shortStint":
                  formDataObject.short_stint = value;
                  break;
                case "longTermJob":
                  formDataObject.long_term_job = value;
                  break;
              }
            });
            break;
          default:
            formDataObject[key] = value;
            break;
        }
      });
    }
    return formDataObject;
  };

  const transformJobData = (data, state) => {
    if (data.pharmacy) {
      data.pharmacy = transformUserData(data.pharmacy, state);
    }
    if (data.locum) {
      data.locum = transformUserData(data.locum, state);
    }
    return data;
  };
  

  const transformPreferredLocumData = (data, state) => {
    if (data.pharmacy) {
      data.pharmacy = transformUserData(data.pharmacy, state);
    }
    if (data.locum) {
      data.locum = transformUserData(data.locum, state);
      data.locum.invitation = data.locumInvitation;
    } else {
      data.locum = {'invitation': data.locumInvitation};

    }
    return data;
  };

  const transformPreferredLocumInvitationData = (data, state) => {
    const respData = {
      name: '',
      profileImage: '',
      ahpra: '',
      ahpraExpiry: '',
      message: '',
      invitationId : '',
      showDetails : false,
      workOutSideMetro: 0,
      workRegionalLessThanFourWeeks: 0,
      considerWorkingMoreThanFourWeeks: 0,
      language: "English",
      minRate:'',
      isCovidCertConfirmed: false
    };
   
    if (data.locum) {
      data.locum = transformUserData(data.locum, state);
    } 

    console.log(data.locum , "Locum data");

    respData.message = "Locum has been invited to Locumate, pending registration";
    respData.invitationId = data.id;


    if (!data.locum) {
      respData.name = data.locumEmail;

      if (data.rejectedAt) {
        data.message = "Rejected by Locum"
      } else if (data.acceptedAt) {
        data.message = "Accepted by Locum pending registration"
      }
    } else {

      respData.name = data.locum.name;
      respData.id = data.locum.id;
      respData.ahpra = data.locum.settings.ahpra ?? '';
      respData.ahpraExpiry = data.locum.settings.ahpraExpDate ?? '';
      respData.willingToWorkOutSideMetro = data.locum.settings.workOutsideMetro ?? 0;
      respData.isCovidCertConfirmed = data.locum.isCovidCertConfirmed ?? false;
      
      // console.log("willing to work", data.locum.settings);
      respData.workRegionalLessThanFourWeeks = data.locum.settings.shortStint ?? 0;
      respData.considerWorkingMoreThanFourWeeks = data.locum.settings.longTermJob ?? 0;
      respData.minRate = data.locum.settings.min_rate ?? 'N/a';
      respData.minRate = data.locum.settings.min_rate ?? 0;
      respData.locum = data.locum;
      respData.schedule = data.locum.schedule;
      respData.image = data.locum.image;

      

      
      
      if (data.rejectedAt) {
        data.message = "Rejected by Locum"
        respData.showDetails  = false;

      } else if (data.acceptedAt) {
        data.message = "Accepted by Locum"
        respData.showDetails  = true;

      }
    }


    console.log("response data", respData)
    return respData; 
  };


  const setShiftStatus = (data, store) => {
    // console.log("🚀 ~ file: transform.js:582 ~ setShiftStatus ~ data:", data)
    let statusText = null;
    let statusClass = null;
    const status = Number(data.status);
    const isInternalLocumShift = Boolean(
      store.getters.GET_USER_DATA?.isInternalLocum ||
      data.locum?.isInternalLocum
    );
    if(isInternalLocumShift){
      console.log("🚀 ~ file: transform.js:582 ~ setShiftStatus ~ data:", data)

        switch (status) {
          case 0:
            statusText = "created";
            statusClass = "internalemployenon created";
            break;
          case 1:
            statusText = "assigned"; //When someone apply a shift. Can be set by a locum
            statusClass = "internalemployenon assigned";
            break;
          case 2:
            statusText = "progress"; //When date of stat less that current date and a shift has a locum. Can be set by CRON
            statusClass = "internalemployenon progress";
            break;
          case 3:
            if (data.invoicing === 1 || data.timeSheet === 1) {
              statusText = "completed"; // Custom status when both conditions are met
              statusClass = "internalemployenon completed " + store.getters.GET_USER_DATA.role;
              break;
            }else{
              statusText = "completed"; //When date of end less than current date and status is "in progress" and a shift has a locum. Can be set by CRON
              statusClass = "internalemployenon none"; // Custom class for invoiced status
              break;
            }
           
          case 4:
            statusText = "submitted"; //When a shift is over and shift`s status "completed". Can be set by a locum with his working time
            statusClass = "internalemployenon submitted " + store.getters.GET_USER_DATA.role;
            break;
          case 5:
            statusText = "verified"; //Can be set by a pharmacy when a shift was submitted
            statusClass = "internalemployenon verified";
            break;
          case 6:
            statusText = "paid"; //Can be set by CRON
            statusClass = "internalemployenon paid";
            break;
          case 7:
            statusText = "finished"; //Can be set by CRON
            statusClass = "internalemployenon finished";
            break;
          case 8:
            statusText = "closed"; //Can be set by an admin
            statusClass = "internalemployenon closed";
            break;
          case 10:
            statusText = "automatically"; //verified automatically.
            statusClass = "internalemployenon automatically";
            break;
          case 15:
              statusText = "didNotWork";
              statusClass = "didNotWork";
              break;
        }
    }else{
      switch (status) {
        case 0:
          statusText = "created";
          statusClass = "created";
          break;
        case 1:
          statusText = "assigned"; //When someone apply a shift. Can be set by a locum
          statusClass = "assigned";
          break;
        case 2:
          statusText = "progress"; //When date of stat less that current date and a shift has a locum. Can be set by CRON
          statusClass = "progress ";
          break;
        case 3:
          statusText = "completed"; //When date of end less than current date and status is "in progress" and a shift has a locum. Can be set by CRON
          statusClass = "completed " + store.getters.GET_USER_DATA.role;
          break;
        case 4:
          statusText = "submitted"; //When a shift is over and shift`s status "completed". Can be set by a locum with his working time
          statusClass = "submitted " + store.getters.GET_USER_DATA.role;
          break;
        case 5:
          statusText = "verified"; //Can be set by a pharmacy when a shift was submitted
          statusClass = "verified";
          break;
        case 6:
          statusText = "paid"; //Can be set by CRON
          statusClass = "paid";
          break;
        case 7:
          statusText = "finished"; //Can be set by CRON
          statusClass = "finished";
          break;
        case 8:
          statusText = "closed"; //Can be set by an admin
          statusClass = "closed";
          break;
        case 9:
          statusText = "disputed"; //Can be opened by a pharmacy with a reason
          statusClass = "disputed";
          break;
        case 10:
          statusText = "automatically"; //verified automatically.
          statusClass = "automatically";
          break;
        case 12:
          statusText = "paynextday"; //verified automatically.
          statusClass = "paynextday";
          break;
        case 13:
          statusText = "guest-shift"; //create guest shift
          statusClass = "guest-shift";
          break;
        case 14:
          statusText = "agencyFullFilled"; //verified automatically.
          statusClass = "agencyFullFilled";
          break;
        case 15:
          statusText = "didNotWork";
          statusClass = "didNotWork";
          break;
      }
    }
   
    data.statusText = statusText;
    data.statusClass = statusClass || "";
    return data;
  };

  const transformShiftData = (data, store) => {
    if (data.pharmacy) {
      data.pharmacy = transformUserData(data.pharmacy);
    }
    if (data.locum) {
      data.locum = transformUserData(data.locum);
    
    }
    data = setShiftStatus(data, store);
    const role = store?.getters?.GET_USER_DATA?.role;
    if (role === "locum" && (
      data.hidePayRateForLocum === true ||
      data.shiftBookedAsInternalStaff
    )) {
      data.payRate = null;
      data.payRateExecSuper = null;
      data.payRateSuper = null;
      data.recommendedRate = null;
    }
    return data;
  };

  return {
    transformUserData,
    transformUserDataForRequest,
    transformJobData,
    transformShiftData,
    transformPreferredLocumData,
    transformPreferredLocumInvitationData
  };
}
